import { renderAndMountComponent } from '../../common';
import { ensureExists } from '@wix/answers-lib';
import { RadioButton, RadioGroup } from './radio-group';
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper, getBaseReactDriver } from '../../common/base-driver';
export var createRadioGroupLegacyDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.radio-group', RadioGroup.name);
    return {
        selectByValue: function (value) {
            var elem = baseDriver.findAll('.radio-button')
                .toArray()
                .find(function (i) { return (i.getAttribute('data-value') || '') === value; });
            ensureExists(elem).click();
        },
        getSelectedValue: function () {
            var value = baseDriver.findAll('.radio-button')
                .filter(function (i) { return i.hasClass('checked'); }).get(0)
                .getAttribute('data-value');
            return ensureExists(value);
        },
        getChildrenByValue: function (value) {
            var elem = ensureExists(baseDriver.findAll('.radio-button')
                .toArray()
                .find(function (i) { return i.getAttribute('data-value') === value; })).elem;
            return getBaseReactDriver(elem);
        },
        wrapper: wrapper
    };
};
export var createRadioGroupComp = function (props) {
    var radioButtonComp = props.items.map(function (item) {
        var isDisabled = props.disabledValues.indexOf(item) > -1;
        return (React.createElement(RadioButton, { value: item, key: item, disabled: isDisabled }, item));
    });
    var radioGroup = (React.createElement(RadioGroup, { onChange: props.onChange, selectedValue: props.items[0] }, radioButtonComp));
    var element = renderAndMountComponent(radioGroup);
    return createRadioGroupLegacyDriver(element);
};
//# sourceMappingURL=radio-group.legacy-driver.js.map